export default "__VITE_ASSET__B0LqHmQ3__"